<template>
  <v-container class="ma-0 pa-0">
    <v-row v-if="loading">
      <v-col cols="12" class="d-flex justify-center py-15">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-col>
    </v-row>

    <template v-else>
      <div class="d-flex align-center justify-space-between mb-4">
        <h2 class="mb-0">{{ $t("Purchases") }}</h2>
        <v-chip color="grey lighten-3" small>
          {{ purchaseData.count || 0 }} {{ $t("total") }}
        </v-chip>
      </div>

      <v-card
        outlined
        class="text-center py-15"
        rounded="xl"
        v-if="!purchaseData.rows || purchaseData.rows.length === 0"
      >
        <v-icon size="50" color="grey lighten-1">mdi-motorbike-off</v-icon>
        <div class="mb-0 ot-text-16 mt-2">
          {{ $t("You haven't purchased any vehicle yet.") }}
        </div>
      </v-card>

      <v-card
        outlined
        rounded="xl"
        class="mb-4"
        v-for="(row, index) in purchaseData.rows"
        :key="index"
      >
        <div class="pa-5">
          <div class="d-flex justify-space-between align-start">
            <div>
              <div class="ot-text-13 text--disabled">
                {{ $t("Purchase ID") }}
              </div>
              <div class="ot-text-16 font-weight-bold">
                {{ row.purchaseId }}
              </div>
            </div>
            <v-chip small :color="paymentStatus(row.paymentStatus).color" text-color="white">
              {{ paymentStatus(row.paymentStatus).label }}
            </v-chip>
          </div>

          <v-divider class="my-3"></v-divider>

          <div class="d-flex justify-space-between py-1">
            <span class="ot-text-14 text--disabled">{{
              $t("Registration Number")
            }}</span>
            <span class="ot-text-14 font-weight-medium">{{
              row.registrationNumber || "-"
            }}</span>
          </div>
          <div class="d-flex justify-space-between py-1">
            <span class="ot-text-14 text--disabled">{{
              $t("Total Amount")
            }}</span>
            <span class="ot-text-16 font-weight-bold">{{
              row.payable | currency
            }}</span>
          </div>

          <v-btn
            color="primary"
            text
            class="mt-2 px-0"
            @click="row.showDetails = true"
          >
            {{ $t("View More Details") }}
            <v-icon right size="18">mdi-chevron-right</v-icon>
          </v-btn>
        </div>

        <v-dialog v-model="row.showDetails" max-width="420">
          <v-card rounded="xl">
            <v-container class="pa-6">
              <div class="d-flex justify-space-between align-center mb-2">
                <h3 class="mb-0">{{ $t("Purchase Details") }}</h3>
                <v-btn icon @click="row.showDetails = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <div
                v-for="(cost, label) in {
                  'ReSale Price': row.reSalePrice,
                  'RSA Cost': row.rsaCost,
                  'Insurance Cost': row.insuranceCost,
                  'Warranty Cost': row.warrantyCost,
                  'RTO Cost': row.rtoCost,
                  Miscellaneous: row.miscCost,
                }"
                :key="label"
                class="d-flex justify-space-between py-1"
              >
                <span class="ot-text-14 text--disabled">{{ $t(label) }}</span>
                <span class="ot-text-14 font-weight-medium">{{
                  cost | currency
                }}</span>
              </div>

              <v-divider class="my-3"></v-divider>
              <div class="d-flex justify-space-between">
                <span class="font-weight-bold">{{ $t("Total") }}</span>
                <span class="font-weight-bold">{{
                  row.payable | currency
                }}</span>
              </div>

              <div class="text-center mt-4">
                <v-chip
                  small
                  :color="paymentStatus(row.paymentStatus).color"
                  text-color="white"
                >
                  {{ $t("Payment") }}: {{ paymentStatus(row.paymentStatus).label }}
                </v-chip>
              </div>
            </v-container>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { test } from "@/services/axios";
export default {
  data() {
    return {
      purchaseData: {},
      loading: true,
    };
  },
  mounted() {
    this.getPurchases();
  },
  methods: {
    paymentStatus(status) {
      if (status === 0) return { label: this.$t("Pending"), color: "warning" };
      if (status === 1) return { label: this.$t("Completed"), color: "success" };
      return { label: this.$t("Failed"), color: "error" };
    },
    async getPurchases() {
      try {
        this.loading = true;
        const { data } = await test.get("/app/customer/purchases");
        this.purchaseData = {
          count: data.count,
          rows: data.rows.map((row) => ({
            purchaseId: row.purchaseId,
            registrationNumber: row.registrationNumber,
            payable: row.payable,
            reSalePrice: row.reSalePrice,
            insuranceCost: row.insuranceCost,
            rtoCost: row.rtoCost,
            rsaCost: row.rsaCost,
            warrantyCost: row.warrantyCost,
            paymentStatus: row.paymentStatus,
            showDetails: false,
          })),
        };
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
